<div class="w-100" [formGroup]="formGroup">
  <div class="d-flex flex-row justify-content-between align-items-center">
    <h2 class="title">{{isEditMode ? 'Edit Stay Informed' : 'Add Stay Informed'}}</h2>
    <div class="btn btn-primary d-flex justify-content-center align-items-center btn-add button" (click)="save()">
      Save
    </div>
  </div>
  <div class="mt-3">
    <div class="d-flex flex-column">
      <span>Name</span>
      <mat-form-field appearance="outline" class=" w-100 input">
        <input matInput required formControlName="name" maxlength="100" placeholder="Enter name here" required>
        <mat-hint align="end">{{formGroup.controls.name.value.length || 0}} / 100</mat-hint>
        <mat-error>{{formGroup.controls.name.errors?.message}}</mat-error>
      </mat-form-field>
    </div>
    <div class="row m-0 align-items-center">
      <span class="col-1 p-0">Type</span>
      <mat-form-field appearance="outline" class="col-2 p-0">
        <mat-select formControlName="type" (selectionChange)="selectionChange()">
          <mat-option value="LINK"> Link </mat-option>
          <mat-option value="FILE"> File </mat-option>
        </mat-select>
      </mat-form-field>
      <ng-container *ngIf="formGroup.controls.type.value === 'LINK'">
        <mat-form-field floatLabel="never" appearance="outline" class="col-9 pr-0">
          <input matInput required formControlName="url" placeholder="Enter URL" maxlength="512" required>
          <mat-hint align="end">{{formGroup.controls.url.value?.length || 0}} / 512</mat-hint>
          <mat-error class="mt-2">{{formGroup.controls.url.errors?.message}}</mat-error>
        </mat-form-field>
      </ng-container>
      <ng-container *ngIf="formGroup.controls.type.value === 'FILE'">
        <!-- <div class="col-8 pb-2 pr-0">
          <span>(Only upload jpg, pdf, doc, docx, xls, xlsx, ppt, pptx and 10MB max file)
          </span>
        </div> -->
        <div class="row col-xl-9 col-lg-12 pb-2 pr-0">
          <div class="row col-xl-2 col-md-4 col-sm-12 col-12 no-gutters py-2 pr-0">
            <button class="btn btn-outline-primary size-button" type="button" (click)=fileInput.click()>
              Choose file
            </button>
            <input #fileInput type="file" name="file-input" style="display: none" accept=".pdf, .doc, .docx, .xlsx, .xls, .jpg, .ppt, .pptx"
              (change)="onFileInput($event)" id="docFile" />
          </div>
          <!-- <div class="row col-xl-2 col-md-3 col-sm-12 col-12 align-items-center py-2 pr-0 col-sxl">
            <button class="btn btn-primary button" (click)="submitMaterialForm()">
              Save file
            </button>
          </div> -->
          <div class="row col-xl-10 col-md-5 col-sm-12 col-12 no-gutters align-items-center py-2 pr-0 col-sxl"
          *ngIf="formGroup?.controls?.resource?.value">
            <div class="pr-3 col-10 ellipsis"
                  [matTooltip]="formGroup?.controls?.resource?.value?.name || formGroup?.controls?.resource?.value?.resourceName">
                  {{ formGroup?.controls?.resource?.value?.name || formGroup?.controls?.resource?.value?.resourceName}}
                </div>
            <mat-icon aria-label="attach file" (click)="removeAttachment()" [matTooltip]="'Remove'">
              close
            </mat-icon>
          </div>
          <div class="row col-xl-10 col-md-5 col-sm-12 col-12 align-items-center pr-0 col-sxl" *ngIf="!formGroup?.controls.resource?.value">
            <div class="pr-3">No file choosen</div>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
</div>